import { Typography, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
  subHeading1: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    color: "#000000",
    fontSize: "1rem",
    lineHeight: "1.688rem",
    margin: "0.5rem 0rem 0rem 0rem",
  },
  subHeading: {
    fontSize: "1rem",
    lineHeight: "1.688rem",
    color: "#212121",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: "1.25rem",
    },
  },
}));

const MallVicinity = () => {
  const classes = useStyles();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm")); // Detect mobile devices

  const malls = [
    { name: "Decathlon", distance: "3.4 KM" },
    { name: "Centro", distance: "6.5 KM" },
    { name: "The Forum Mall Koramangala", distance: "9.2 KM" },
  ];

  // Show only the first 3 malls on mobile
  const displayedMalls = isMobile ? malls.slice(0, 4) : malls;

  return (
    <React.Fragment>
      {displayedMalls.map((mall, index) => (
        <div
          className={classes.subHeading1}
          key={index}
        >
          <Typography className={classes.subHeading}>{mall.name}</Typography>
          <Typography className={classes.subHeading}>{mall.distance}</Typography>
        </div>
      ))}
    </React.Fragment>
  );
};

export default MallVicinity;
